import "./VistiPerStudioStudenti.module.css";
import Header from "@/reusable_sections/Header";
import PracticeManagementReimagined from "./sections/PracticeManagementReimagined";
import DuvidasFrequentes from "./sections/DuvidasFrequentes";
import ContattaciStudenti from "./sections/ContattaciStudenti";
import Footer from "@/reusable_sections/Footer";
export default function VistiPerStudioStudentiPage() {
  return <div>
      <Header />
      <PracticeManagementReimagined />
      <DuvidasFrequentes />
      <ContattaciStudenti />
      <Footer />
    </div>;
}